// extracted by mini-css-extract-plugin
export var contentBody = "_44-9";
export var headerImage = "_44-2";
export var imageButton = "_44-7";
export var imageButtonIcon = "_44-8";
export var imageHeader = "_44-4";
export var imageHeaderText = "_44-5";
export var imageOverlay = "_44-3";
export var imageTitle = "_44-6";
export var imageWrapper = "_44-1";
export var taskList = "_44-a";
export var widget = "_44-0";